import RandingStyle4 from "../../randing/RandingStyle4";
import RandingStyle5 from "../../randing/RandingStyle5";

function Randing003({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_01.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_06.jpg`} // 스텝 변경되는 이미지
      numberColor="#3f8c58"
      benefitInfoPosition="top"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      articleOption={true}
    />
  );
}

export default Randing003;
